import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_update_last_wavelength_transmissionService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { transaction_id?: string, transmission_direction?: string, transmission_type?: string, notes?: string }): Promise<void> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/update_last_wavelength_transmission`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

